import {
    GET_STORE_SUCCESS,
    GET_STORE_FILTER_SUCCESS
} from './types'
import axios from 'axios';


export const get_store_alls = (filter) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    };
    try {
        let params = {
            search: filter?.search || "",
            filter_id: filter?.filter_id || "",
            page: filter?.page || 1,
        };
        const res = await axios.get(`${process.env.REACT_APP_API_URL}api/store/alls`,{ params }, config);
        console.log(res);
            dispatch({
                type: GET_STORE_SUCCESS,
                payload: res.data.data
            });

    } catch (err) {

    }
};

export const get_filters = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        }
    };
    try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}api/store/departamento`, config);

        dispatch({
            type: GET_STORE_FILTER_SUCCESS,
            payload: res.data
        });

    } catch (err) {

    }
};

